export type SearchableValue = string | number | null | undefined

/** U+00A0, from a char code so it can't be lost to an invisible edit. */
const NON_BREAKING_SPACE = new RegExp(String.fromCharCode(160), 'g')

/** Keeps case, so the result is still presentable — this is the string highlighting renders. */
export const foldForSearch = (value: SearchableValue): string =>
   value === null || value === undefined ? '' : value.toString().replace(NON_BREAKING_SPACE, ' ').normalize('NFC')

/**
 * Diacritics are deliberately NOT stripped: å/ä/ö are separate letters in Swedish, not accented
 * a/o, so "a" must never match "ä" — which also rules out localeCompare with sensitivity 'base'.
 */
export const normalizeForSearch = (value: SearchableValue): string => foldForSearch(value).toLocaleLowerCase('sv')

export type SearchField = {
   value: SearchableValue
   /** Supplied from a cache to skip re-normalizing on every query. */
   normalized?: string
}

/** Fields are matched individually, never joined, so a hit can't span a column boundary. */
export const matchesAnyField = (fields: SearchField[], normalizedQuery: string): boolean =>
   fields.some((field) => (field.normalized ?? normalizeForSearch(field.value)).includes(normalizedQuery))
